import React, { Component } from 'react'
import indexOf from 'lodash/indexOf'

export interface Props {
  location: Location
}

export class NoMatchView extends Component<Props> {
  static displayName = 'NoMatch'

  render() {
    const { pathname } = this.props.location
    let statusCode = pathname.substr(pathname.lastIndexOf('/') + 1)
    let statusHeadline = "Sometimes getting lost isn't so bad."
    const codes = ['400', '401', '403', '404', '500', '504']

    if (!pathname.includes('error') || indexOf(codes, statusCode) === -1) {
      statusCode = '404'
    }

    if (statusCode === '400') {
      statusHeadline = 'Uh Oh! Bad Request!'
    }

    if (statusCode === '401') {
      statusHeadline = "Uh Oh! You're not authorized!"
    }

    if (statusCode === '403') {
      statusHeadline = 'Uh Oh! Forbidden page!'
    }

    if (statusCode === '500') {
      statusHeadline = 'Uh Oh! Something went wrong!'
    }

    if (statusCode === '504') {
      statusHeadline = 'Uh Oh! Your request timed out. Try again later.'
    }

    return (
      <div data-test="no-match-container">
        <div className="error-container">
          <h1 className="status-code">{statusCode}</h1>
          <h2 className="h1 status-title">{statusHeadline}</h2>
        </div>
      </div>
    )
  }
}

export const NoMatch = NoMatchView
